import { InvoiceEventType } from '@features/invoices/enums/invoiceEventType'

import { DemoInvoiceSendChannel } from '../enums/demoInvoiceSendChannel'

export const DEMO_INVOICE_SEND_CHANNEL_TO_EVENT_TYPE: Record<DemoInvoiceSendChannel, InvoiceEventType> = {
  [DemoInvoiceSendChannel.Download]: InvoiceEventType.DocumentPdfDownloaded,
  [DemoInvoiceSendChannel.EInvoice]: InvoiceEventType.DeliveryInhouseEinvoiceSent,
  [DemoInvoiceSendChannel.Email]: InvoiceEventType.DeliveryEmailSent,
}
